import React from "react";
import useTranslation from "../../../hooks/useTranslation";

export default function AddPatientModal({ show, onClose, patientForm, setPatientForm, onSubmit, doctors }) {
  const { t } = useTranslation();
  if (!show) return null;
  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <h2>{t('Add New Patient')}</h2>
        <form onSubmit={onSubmit}>
          <div className="admin-row">
            <label>{t('Name')} *</label>
            <input type="text" required value={patientForm.name} onChange={(e) => setPatientForm({...patientForm, name: e.target.value})} />
          </div>
          <div className="admin-row">
            <label>{t('Doctor')} *</label>
            <select required value={patientForm.doctor_id} onChange={(e) => setPatientForm({...patientForm, doctor_id: e.target.value})}>
              <option value="">{t('Select Doctor')}</option>
              {doctors.map(d => (
                <option key={d.user_id} value={d.user_id}>{d.display_name || d.user_name}</option>
              ))}
            </select>
          </div>
          <div className="admin-row">
            <label>{t('Age')}</label>
            <input type="number" value={patientForm.age} onChange={(e) => setPatientForm({...patientForm, age: e.target.value})} />
          </div>
          <div className="admin-row">
            <label>{t('Contact')}</label>
            <input type="text" value={patientForm.contact} onChange={(e) => setPatientForm({...patientForm, contact: e.target.value})} />
          </div>
          <div className="admin-row">
            <label>{t('Address')}</label>
            <input type="text" value={patientForm.address} onChange={(e) => setPatientForm({...patientForm, address: e.target.value})} />
          </div>
          <div style={{ display: 'flex', gap: 8, marginTop: 16 }}>
            <button type="submit" className="btn btn-primary">{t('Create Patient')}</button>
            <button type="button" className="btn" onClick={onClose}>{t('Cancel')}</button>
          </div>
        </form>
      </div>
    </div>
  );
}
